var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg17DatumFix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aDatumFix{fill:none;}.bDatumFix{fill:#b3090f;}.cDatumFix{fill:#707070;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "aDatumFix background-transparent",
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "bDatumFix",
    d: "M567.162,213.374h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm-42,7h4v4h-4Zm7,0h4v4h-4Z",
    transform: "translate(-528.162 -161.373)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cDatumFix",
    d: "M553.162,216.865h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm-42,7h4v4h-4Zm7,0h4v4h-4Zm7,7h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm-42,7h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm7,0h4v4h-4Zm4-47.018v-3.982h-4v3.982h-38v-3.982h-4v3.982h-8.017v60.035H607.18V190.847Zm-49.982,4.035h3.982v3.983h4v-3.983h38v3.983h4v-3.983h3.983v7.983H549.18Zm53.965,27.983v23.982H549.18V206.865h53.965v16Z",
    transform: "translate(-528.145 -171.865)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17DatumFix);
export default __webpack_public_path__ + "static/media/17_datum_fix.cacea0a27392caabc46b7cad3a3c5975.svg";
export { ForwardRef as ReactComponent };